var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-sortable",
    {
      attrs: {
        tag: "w-list",
        "target-class": "handle",
        items: _vm.settings.Cols,
      },
    },
    [
      _vm._l(_vm.settings.Cols, function (col, i) {
        return _c(
          "w-list-item",
          { key: col.uid, attrs: { "show-handle": "" } },
          [
            _c("w-list-item-text", [_vm._v(_vm._s(col.toString()))]),
            _c(
              "w-list-item-action",
              [
                _c(
                  "w-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.editColumn(col)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "pen" } })],
                  1
                ),
              ],
              1
            ),
            _c(
              "w-list-item-action",
              [
                _c(
                  "w-button",
                  {
                    staticClass: "danger",
                    on: {
                      click: function ($event) {
                        return _vm.deleteColumn(i)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "trash" } })],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm.settings.Cols.length == 0
        ? _c(
            "w-list-item",
            { key: "no-items-message" },
            [
              _c("w-list-item-text", [
                _vm._v(_vm._s(_vm.$ct("no-column-settings-added"))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-list-item",
        {
          key: "add-button",
          on: {
            click: function ($event) {
              return _vm.addColumn()
            },
          },
        },
        [
          _c("w-list-item-icon", [_c("w-fa", { attrs: { icon: "plus" } })], 1),
          _c("w-list-item-text", [
            _vm._v(_vm._s(_vm.$ct("add-column-setting"))),
          ]),
        ],
        1
      ),
      _vm.toEditColumn
        ? _c("app-edit-column", {
            key: "modal",
            attrs: {
              "known-headers": _vm.knownHeaders,
              value: _vm.toEditColumn,
              "allowed-output-headers": _vm.allowedOutputHeaders,
            },
            on: {
              close: function ($event) {
                _vm.toEditColumn = null
              },
              input: function ($event) {
                return _vm.onEditColInput($event)
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }